import { render } from "./FooterComponent.vue?vue&type=template&id=1c2455de&bindings={\"Year\":\"setup\"}"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script